import TokenResponse from 'owa-service/lib/contract/TokenResponse';
import tokenRequest from 'owa-service/lib/factory/tokenRequest';
import RequestOptions from 'owa-service/lib/RequestOptions';
import sleep from 'owa-sleep';
import getAccessTokenforResourceOperation from 'owa-service/lib/operation/getAccessTokenforResourceOperation';

const RETRY_DELAY = 500;

export default async function getAccessTokenforResourceFromServer(
    resource: string
): Promise<TokenResponse> {
    const options: RequestOptions = { isUserActivity: false };
    return getAccessTokenforResourceOperation(tokenRequest({ Resource: resource }), options);
}

/**
 * Adds a retry with timeout when fetching Access Token from server
 * @param resource - the resource string
 * @param retryCount - the retry count
 * @returns - TokenResponse wrapped around in a Promise
 */
export async function getAccessTokenforResourceFromServerWithRetry(
    resource: string,
    retryCount: number
): Promise<TokenResponse> {
    if (retryCount < 1) {
        return Promise.reject();
    }

    return getAccessTokenforResourceFromServer(resource).catch(() =>
        sleep(RETRY_DELAY).then(() => {
            return getAccessTokenforResourceFromServerWithRetry(resource, retryCount - 1);
        })
    );
}
